import { render, staticRenderFns } from "./datacenter.vue?vue&type=template&id=795062a0&scoped=true&"
import script from "./datacenter.vue?vue&type=script&lang=ts&"
export * from "./datacenter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795062a0",
  null
  
)

export default component.exports